<div class="max-w-md mx-auto flex flex-col mt-4 relative overflow-hidden">
  <div class="flex justify-center item-center mt-10">
    <h6 class="text-2xl font-semibold text-gray-800">
      Create a new
      <span class="italic text-amazone-orange">Error Code</span>
    </h6>
  </div>
  <form [formGroup]="form">
    <div
      class="grid gap-6 mt-6 md:grid-cols-6 border-b border-gray-900/10 pb-6 overflow-y-auto h-[calc(100vh-10rem)] px-4"
    >
      <div class="col-span-full pt-4">
        <app-label-with-help for="code" class="primary-label" fieldConfigurationAddress="errorcode.code"
          >Code</app-label-with-help
        >
        <input
          type="text"
          id="code"
          class="primary-field"
          [placeholder]="errorCodeCodePlaceholder"
          required
          [formControl]="code"
        />
      </div>
      <div class="col-span-full pt-4">
        <app-label-with-help for="nwNumbers" class="primary-label" fieldConfigurationAddress="errorcode.nwNumbers"
          >NW Numbers</app-label-with-help
        >
        <select
          id="nwNumbers"
          [formControl]="nwNumbers"
          multiple
          size="4"
          class="border w-full text-sm rounded-lg block p-2.5 bg-amazone-gray border-amazone-gray hover:bg-gray-800 placeholder-gray-400 text-white focus:ring-amazone-orange focus:border-amazone-orange disabled:cursor-not-allowed"
        >
          @for (nwNumber of nwNumberValues; track nwNumber) {
            <option [value]="nwNumber.id">
              {{ nwNumber.title }}
            </option>
          }
        </select>
      </div>

      <div class="col-span-full pt-4">
        <app-text-area
          [fieldIsRequired]="true"
          [fieldConfigurationAddress]="'errorcode.message'"
          [label]="'Message'"
          [formControl]="message"
          [displayChangeIndicator]="false"
        ></app-text-area>
      </div>

      <div
        class="col-span-full grid gap-y-2 border border-amazone-gray-light/30 rounded-md p-4 hover:shadow-lg transition-shadow duration-300"
      >
        <div class="col-span-full pt-4">
          <app-text-area
            [fieldConfigurationAddress]="'errorcode.causeFarmer'"
            [label]="'Cause (Farmer)'"
            [formControl]="causeFarmer"
            [displayChangeIndicator]="false"
          ></app-text-area>
        </div>

        <div class="col-span-full pt-4">
          <app-text-area
            [fieldConfigurationAddress]="'errorcode.remedyFarmer'"
            [label]="'Remedy (Farmer)'"
            [formControl]="remedyFarmer"
            [displayChangeIndicator]="false"
          ></app-text-area>
        </div>
      </div>

      <div
        class="col-span-full grid gap-y-2 border border-amazone-gray-light/30 rounded-md p-4 hover:shadow-lg transition-shadow duration-300"
      >
        <div class="col-span-full pt-4">
          <app-text-area
            [fieldConfigurationAddress]="'errorcode.causeDealer'"
            [label]="'Cause (Dealer)'"
            [formControl]="causeDealer"
            [displayChangeIndicator]="false"
          ></app-text-area>
        </div>
        <div class="col-span-full pt-4">
          <app-text-area
            [fieldConfigurationAddress]="'errorcode.remedyDealer'"
            [label]="'Remedy (Dealer)'"
            [formControl]="remedyDealer"
            [displayChangeIndicator]="false"
          ></app-text-area>
        </div>
      </div>

      <div
        class="col-span-full grid gap-y-2 border border-amazone-gray-light/30 rounded-md p-4 hover:shadow-lg transition-shadow duration-300"
      >
        <div class="col-span-full pt-4">
          <app-text-area
            [fieldConfigurationAddress]="'errorcode.causeIntern'"
            [label]="'Cause (Intern)'"
            [formControl]="causeIntern"
            [displayChangeIndicator]="false"
          ></app-text-area>
        </div>

        <div class="col-span-full pt-4">
          <app-text-area
            [fieldConfigurationAddress]="'errorcode.remedyIntern'"
            [label]="'Remedy (Intern)'"
            [formControl]="remedyIntern"
            [displayChangeIndicator]="false"
          ></app-text-area>
        </div>
      </div>

      <div class="col-span-full pt-4">
        <app-text-area
          [fieldConfigurationAddress]="'errorcode.startingWithVersion'"
          [label]="'Available starting with version'"
          formControlName="startingWithVersion"
          [displayChangeIndicator]="false"
          [rows]="1"
        ></app-text-area>
      </div>

      <div class="col-span-full pt-4">
        <app-text-area
          [fieldConfigurationAddress]="'errorcode.endingWithVersion'"
          [label]="'Last version available in'"
          formControlName="endingWithVersion"
          [displayChangeIndicator]="false"
          [rows]="1"
        ></app-text-area>
      </div>

      <div class="col-span-full pt-4">
        <app-text-area
          [fieldConfigurationAddress]="'errorcode.MachineType'"
          [label]="'Machine Type(s)'"
          [formControl]="machineType"
          [displayChangeIndicator]="false"
        ></app-text-area>
      </div>

      <div class="flex items-start col-span-full pt-4">
        <div class="flex items-center h-5">
          <input
            type="checkbox"
            [formControl]="needsReview"
            name="needsReview"
            id="needsReview"
            class="primary-checkbox"
          />
        </div>
        <app-label-with-help
          for="needsReview"
          class="ms-2 primary-label w-full"
          fieldConfigurationAddress="errorcode.needsReview"
          >Needs Review</app-label-with-help
        >
      </div>

      <div class="flex items-start col-span-full pt-4">
        <div class="flex items-center h-5">
          <input
            type="checkbox"
            [formControl]="fitnessExclude"
            name="fitnessExclude"
            id="fitnessExclude"
            class="primary-checkbox"
          />
        </div>
        <app-label-with-help
          for="fitnessExclude"
          class="ms-2 primary-label w-full"
          fieldConfigurationAddress="errorcode.fitnessExclude"
          >Fitness Exclude</app-label-with-help
        >
      </div>

      <div class="flex items-start col-span-full pt-4">
        <div class="flex items-center h-5">
          <input
            type="checkbox"
            [formControl]="aggregateMessage"
            name="aggregateMessage"
            id="aggregateMessage"
            class="primary-checkbox"
          />
        </div>
        <app-label-with-help
          for="aggregateMessage"
          class="ms-2 primary-label w-full"
          fieldConfigurationAddress="errorcode.aggregateMessage"
          >Aggregate Message</app-label-with-help
        >
      </div>

      <div class="col-span-full pt-4">
        <app-label-with-help for="category" class="primary-label" fieldConfigurationAddress="errorcode.category"
          >Category</app-label-with-help
        >
        <app-selection
          [formControl]="category"
          [options]="errorCodeCategories"
          [invalidOption]="errorCodeCategories[0].id"
        ></app-selection>
      </div>

      <div class="col-span-full pt-4">
        <app-text-area
          [label]="'Internal notes'"
          [fieldConfigurationAddress]="'errorcode.internalNotes'"
          [fieldIsRequired]="false"
          [formControl]="internalNotes"
          [displayChangeIndicator]="false"
        ></app-text-area>
      </div>

      <div class="col-span-full flex justify-end">
        <button
          data-tooltip-target="tooltip-generate"
          type="button"
          [disabled]="form.invalid"
          (click)="createErrorCode()"
          class="crud-btn-create"
          appAgentAction
          agent="new-error-code-create"
          businessObject="errorCode"
          action="create"
        >
          <app-floppy-icon></app-floppy-icon>
        </button>
        <div
          id="tooltip-generate"
          role="tooltip"
          class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-xs opacity-0 tooltip dark:bg-gray-700"
        >
          Enter values for all required fields!
          <div class="tooltip-arrow" data-popper-arrow></div>
        </div>
      </div>
    </div>
  </form>
</div>
